// src/App.jsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './Website/LandingPage';
import TermsOfService from './Website/TermsOfService';
import PrivacyPolicy from './Website/PrivacyPolicy';
import Navbar from './Website/Navbar';
import ContactUs from './Website/ContactUs';
import CheckoutPage from './Website/CheckoutPage';

import UpgradeSuccess from './Website/UpgradeSuccess';
import UpgradeCancelled from './Website/UpgradeCancelled';

const App = () => {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/support" element={<ContactUs />} />
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/pricing" element={<LandingPage />} />
        <Route path="/upgrade-success" element={<UpgradeSuccess />} />
        <Route path="/upgrade-cancelled" element={<UpgradeCancelled />} />
      </Routes>
    </Router>
  );
};

export default App;
